import * as React from "react";
const SvgFiRrDisplayArrowDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 8v6c0 2.757-2.243 5-5 5h-6v1h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-1H5c-2.757 0-5-2.243-5-5V7.983c0-1.34.523-2.599 1.474-3.544a4.97 4.97 0 0 1 3.527-1.456h.026L8.006 3A1 1 0 0 1 8 5h-.006l-2.978-.017c-.799-.03-1.562.306-2.133.874a2.98 2.98 0 0 0-.884 2.126V14c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3h-3a1 1 0 1 1 0-2h3A5.007 5.007 0 0 1 24 8M8.681 7.267A1 1 0 1 0 7.32 8.733l2.587 2.4c.58.581 1.344.869 2.104.869.75 0 1.497-.282 2.058-.843l2.613-2.426a1 1 0 0 0-1.361-1.466l-2.319 2.154V1a1 1 0 1 0-2 0v8.42L8.683 7.267z"
    />
  </svg>
);
export default SvgFiRrDisplayArrowDown;
